import { DateFormatModel } from '../models/date-format.model';

export const dateFormats: DateFormatModel[] = [
    {
        id: 1,
        name: 'DateFormats.1',
        value: 'MM/dd/yyyy',
        momentFormat: 'MM/DD/YYYY',
        twigFormat: 'm/d/Y'
    },
    {
        id: 2,
        name: 'DateFormats.2',
        value: 'dd/MM/yyyy',
        momentFormat: 'DD/MM/YYYY',
        twigFormat: 'd/m/Y'
    },
    {
        id: 3,
        name: 'DateFormats.3',
        value: 'dd-LLL-yyyy',
        momentFormat: 'DD-MMM-YYYY',
        twigFormat: 'd-M-Y'
    },
    {
        id: 4,
        name: 'DateFormats.4',
        value: 'LLLL dd, yyyy',
        momentFormat: 'MMMM DD, YYYY',
        twigFormat: 'F d, Y'
    },
    {
        id: 5,
        name: 'DateFormats.5',
        value: 'LLL dd, yyyy',
        momentFormat: 'MMM DD, YYYY',
        twigFormat: 'M d, Y'
    },
    {
        id: 6,
        name: 'DateFormats.6',
        value: 'd/M/yyyy',
        momentFormat: 'D/M/YYYY',
        twigFormat: 'j/n/Y'
    },
    {
        id: 7,
        name: 'DateFormats.7',
        value: 'dd/MM/yy',
        momentFormat: 'DD/MM/YY',
        twigFormat: 'd/m/y'
    },
    {
        id: 8,
        name: 'DateFormats.8',
        value: 'dd-MM-yyyy',
        momentFormat: 'DD-MM-YYYY',
        twigFormat: 'd-m-Y'
    },
    {
        id: 9,
        name: 'DateFormats.9',
        value: 'MM/dd/yy',
        momentFormat: 'MM/DD/YY',
        twigFormat: 'm/d/y'
    },
    {
        id: 10,
        name: 'DateFormats.10',
        value: 'M/d/yyyy',
        momentFormat: 'M/D/YYYY',
        twigFormat: 'n/j/Y'
    },
    {
        id: 11,
        name: 'DateFormats.11',
        value: 'M/d/yy',
        momentFormat: 'M/D/YY',
        twigFormat: 'n/j/y'
    },
    {
        id: 12,
        name: 'DateFormats.12',
        value: 'yyyy-MM-dd',
        momentFormat: 'YYYY-MM-DD',
        twigFormat: 'Y-m-d'
    },
    {
        id: 13,
        name: 'DateFormats.13',
        value: 'dd LLLL, yyyy',
        momentFormat: 'DD MMMM, YYYY',
        twigFormat: 'd F, Y'
    },
    {
        id: 14,
        name: 'DateFormats.14',
        value: 'dd LLL, yyyy',
        momentFormat: 'DD MMM, YYYY',
        twigFormat: 'd M, Y'
    }
];
